import { render, staticRenderFns } from "./DocTemplateEdit.vue?vue&type=template&id=6c68bf36&"
import script from "./DocTemplateEdit.vue?vue&type=script&lang=ts&"
export * from "./DocTemplateEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports